// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CommunityRules_activeTab__J39dQ {
  color: #1976d2 !important;
  border-color: #1976d2 !important;
  background-color: #eff5fb !important;
}
.CommunityRules_inactiveTab__eH3JQ {
  color: #373334 !important;
  border-color: #c4c4c4 !important;
  background-color: #ffffff !important;
}
/* @media all and (max-width: 480px) {
  .activeTab {
    font-size: 10px !important;
  }
  .inactiveTab {
    font-size: 10px !important;
  }
} */


/* Toggle Switch Container */
.CommunityRules_toggleSwitch__HS2U5 {
    position: relative;
    display: inline-block;
    width: 34px;
    height: 20px;
  }
  
  /* Hide Default Checkbox */
  .CommunityRules_toggleSwitch__HS2U5 input {
    opacity: 0;
    width: 0;
    height: 0;
  }
  
  /* The Slider */
  .CommunityRules_slider__XG1xR {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    transition: 0.4s;
    border-radius: 20px;
  }
  
  /* The Slider Circle */
  .CommunityRules_slider__XG1xR:before {
    position: absolute;
    content: "";
    height: 14px;
    width: 14px;
    left: 3px;
    bottom: 3px;
    background-color: white;
    transition: 0.4s;
    border-radius: 50%;
  }
  
  /* When Checked */
  input:checked + .CommunityRules_slider__XG1xR {
    background-color: #4795DE; /* Blue Color */
  }
  
  input:checked + .CommunityRules_slider__XG1xR:before {
    transform: translateX(14px); /* Move the Circle */
  }
  `, "",{"version":3,"sources":["webpack://./src/Modules/Moderator/EditCommunity/CommunityRules.module.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,gCAAgC;EAChC,oCAAoC;AACtC;AACA;EACE,yBAAyB;EACzB,gCAAgC;EAChC,oCAAoC;AACtC;AACA;;;;;;;GAOG;;;AAGH,4BAA4B;AAC5B;IACI,kBAAkB;IAClB,qBAAqB;IACrB,WAAW;IACX,YAAY;EACd;;EAEA,0BAA0B;EAC1B;IACE,UAAU;IACV,QAAQ;IACR,SAAS;EACX;;EAEA,eAAe;EACf;IACE,kBAAkB;IAClB,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,sBAAsB;IACtB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA,sBAAsB;EACtB;IACE,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,WAAW;IACX,SAAS;IACT,WAAW;IACX,uBAAuB;IACvB,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA,iBAAiB;EACjB;IACE,yBAAyB,EAAE,eAAe;EAC5C;;EAEA;IACE,2BAA2B,EAAE,oBAAoB;EACnD","sourcesContent":[".activeTab {\r\n  color: #1976d2 !important;\r\n  border-color: #1976d2 !important;\r\n  background-color: #eff5fb !important;\r\n}\r\n.inactiveTab {\r\n  color: #373334 !important;\r\n  border-color: #c4c4c4 !important;\r\n  background-color: #ffffff !important;\r\n}\r\n/* @media all and (max-width: 480px) {\r\n  .activeTab {\r\n    font-size: 10px !important;\r\n  }\r\n  .inactiveTab {\r\n    font-size: 10px !important;\r\n  }\r\n} */\r\n\r\n\r\n/* Toggle Switch Container */\r\n.toggleSwitch {\r\n    position: relative;\r\n    display: inline-block;\r\n    width: 34px;\r\n    height: 20px;\r\n  }\r\n  \r\n  /* Hide Default Checkbox */\r\n  .toggleSwitch input {\r\n    opacity: 0;\r\n    width: 0;\r\n    height: 0;\r\n  }\r\n  \r\n  /* The Slider */\r\n  .slider {\r\n    position: absolute;\r\n    cursor: pointer;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    background-color: #ccc;\r\n    transition: 0.4s;\r\n    border-radius: 20px;\r\n  }\r\n  \r\n  /* The Slider Circle */\r\n  .slider:before {\r\n    position: absolute;\r\n    content: \"\";\r\n    height: 14px;\r\n    width: 14px;\r\n    left: 3px;\r\n    bottom: 3px;\r\n    background-color: white;\r\n    transition: 0.4s;\r\n    border-radius: 50%;\r\n  }\r\n  \r\n  /* When Checked */\r\n  input:checked + .slider {\r\n    background-color: #4795DE; /* Blue Color */\r\n  }\r\n  \r\n  input:checked + .slider:before {\r\n    transform: translateX(14px); /* Move the Circle */\r\n  }\r\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"activeTab": `CommunityRules_activeTab__J39dQ`,
	"inactiveTab": `CommunityRules_inactiveTab__eH3JQ`,
	"toggleSwitch": `CommunityRules_toggleSwitch__HS2U5`,
	"slider": `CommunityRules_slider__XG1xR`
};
export default ___CSS_LOADER_EXPORT___;
